import React from "react";
import "./SideBar.css";

function SideBar({ children }) {
  return <div className="sideBar px-4">{children}</div>;
}

export default SideBar;
